export default [
    {
        label: 'Select an medium',
        value: '',
    },
    {
        label: 'CPC',
        value: 'cpc'
    },
    {
        label: 'Banner',
        value: 'banner'
    },
    {
        label: 'Email',
        value: 'email'
    },
    {
        label: 'Other',
        value: 'other'
    }
];